import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT_PX = 640;

const QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX}px)`;

// Pure decision extracted for unit testing (the SPA has no React Testing Library,
// so the hook itself is exercised by the build + manual emulation).
export const matchesMobile = (width: number) => width <= MOBILE_BREAKPOINT_PX;

// Single source of truth for "are we on a mobile viewport". Reactive to resize
// and device-rotation via matchMedia (same primitive lib/theme.ts already uses).
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(QUERY).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    // Re-sync in case the viewport changed between initial state and effect mount.
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
